import { injectable, inject } from "inversify";
import IdentityService from "./identity.service";
import HttpService from "./http.service";
import ToastService from "./toast.service";
import { ArtworkService } from "./openapi/generated";

@injectable()
export default class BlockchainService {
    get isValid() {
        return true;
    }

    @inject(IdentityService)
    public identity: IdentityService;

    @inject(HttpService)
    public httpService: HttpService;

    @inject(ToastService)
    public toastService: ToastService;

    public myAbi;
    public myfunction;

    public interval;

    constructor() {}

    public check = () => {
        // TODO: delete?
    }

    public getToken() {
        const [err, value] = IdentityService.storage.get("token");
        return value;
    }

    public getArtworkDetails = (id: number) => {
        return new Promise<any>((resolve, reject) => {
            this.httpService
                .get(`artwork?id=${id}`, {
                    Authorization: `Bearer ${this.getToken()}`,
                })
                .then((result) => {
                    resolve(result);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    public getArtworkOwner = (id) => {
        return Promise.resolve("");
    }

    public getArtworkOwnerList = (id: number) => {
        return new Promise<any>((resolve, reject) => {
            ArtworkService.artworkControllerGetArtworkOwners(id)
                .then((result) => {
                    resolve(result);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    public getLastArtworkId = (): Promise<any> => {
        return Promise.resolve("");
    }

    public sendArtwork = (walletTo: string, id: string, gas = 4000000, from?: any): Promise<any> => {
        return new Promise<any>((resolve, reject) => {
            this.httpService
                .post("artwork/transfer", {
                    // TODO: artwork id and edition from string id?
                    artworkId: 1,
                    edition: 1,
                    // TODO: userId instead of wallet
                    receiver: walletTo,
                })
                .then((result) => {
                    resolve(true);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public ownArtToken = async (id: any): Promise<boolean> => {
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/services/blockchain.service.ts